<template>
	<div class="view-funnyplaylist-warp">

		<!-- 城事精选 	-->
		<div v-show="true" class="menu-components" style="height: 100%;">
			<div class="quancun-list-wrap">
				<van-list v-model="loading" :finished="finished" @load="onLoad" loading-text = "正在加载..." :offset="300">
					<van-cell v-for="(item,index) in list" :key="index"  @click="displayArticle(item.ID,newsType)">
						<div>  
							<div class="quancun-list-img"  v-lazy:background-image="item.thumbnail">
							  <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
							</div>							
							<div class="newbao-list-content">
								<div class="content-title">{{item.LongTitle}}</div>								
								<div class="quancun-list-bottom">
									<span>{{item.categoryName}}</span>
									<span  class="eye-wrap"><img class="eye" src="static/img/eye.png"/>{{item.visits}}</span>
								</div>
							</div>
						</div>
					</van-cell>
				</van-list>
      <div v-show="listGoneVisible" class="list-gone van-list__loading-text">
                      我可是有底线的！
        </div>
			</div>
			<div style="height:1.37rem;"></div>
		</div>
		<!-- 文章内容 -->
		<div v-show="true" class="article-components"   v-bind:style="{ transform:articleY}" > 
        <img class="btn-comments" src="static/img/comments/btn-comments.png" @click="handleComment"/>
        <span class="comments-total">{{commentTotal}}</span>
				<van-loading class="conents-loading" color="white" v-if="conentsLoading"/>				
			 <iframe @load="iframeLoaded"  :src="articleSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: relative" ></iframe>
		</div>
		<!-- 文章内容 end-->
		  
    <!-- 评论 -->
    <div v-show="commentVisible" class="comment-components" v-bind:style="{ transform:commentY}"> 
     <comments ref="articleComments" contents-id="58691"></comments>
     <van-icon name="upgrade" class="comment-close" @click="closeComment"/>
    </div>
    <!-- 评论 END-->    
      
		<!-- 底部导航 -->
		<van-tabbar v-model="active" class="bottom-nav" v-bind:style="{ backgroundColor:  activeColor }">
			<van-tabbar-item :to="{path:'/',query:{view:1}}">
				<span>鲜料</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.newsActive : icon.news" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item :to="'/maps'">
				<span>智图</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.mapsActive : icon.maps"  />
				</template>
			</van-tabbar-item>
			<van-tabbar-item @click="handleNavPlay">
				<span>趣玩</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.payActive : icon.pay"/>
				</template>
			</van-tabbar-item>
			<van-tabbar-item :to="{path:'/',query:{view:4}}">
				<span>服务</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.serviceActive: icon.service"  />
				</template>
			</van-tabbar-item>
		</van-tabbar>
    <!-- 底部导航 end -->
	</div>
</template>

<script>
	import { Tabbar, TabbarItem, CellGroup,List, Cell,Loading,Icon } from 'vant'
  import qs from 'qs'
  import moment from 'moment'
  import request from '@/utils/request'
   import comments from '@/components/comments.vue'
  
  export default {
    name: 'NewsList',
    components: {
      'comments':comments,
        'van-icon':Icon,
      'van-tabbar': Tabbar,
      'van-tabbar-item': TabbarItem,        
      'van-cell-group': CellGroup,
      'van-cell': Cell, 
      'van-list': List, 
      'van-loading': Loading,
    },
		data() {
			return {
				active: 2,
				icon: {
					news: 'static/img/tabbar/white/news.png',
					newsActive: 'static/img/tabbar/white/news-active.png',
					maps: 'static/img/tabbar/white/map5.png',
					mapActive: 'static/img/tabbar/white/map-active.png',
					pay: 'static/img/tabbar/white/pay.png',
					payActive: 'static/img/tabbar/white/pay-active.png',
					service: 'static/img/tabbar/white/service.png',
					serviceActive: 'static/img/tabbar/white/service-active.png',
				},     
            listQuery: {
              pageIndex: 1,
              pageSize: 10,
            }
        ,
        back:'',
        newsType:0,
        newsZid:0,
				activeColor: "#222633",
				lastLoadTime:0,
				//鲜料
				newComponentsShow: false,
				titleHeight: '55px',
				navIconHeight: '0',
				newClass: {
					activeHeight: '0',
					articleHeight:'0',
				},

      //-评论======
        commentTotal:0,
        commentY:'translateY(-100%)',
        commentVisible:false,
        //-评论 end ===




				/* 文章 */
        articleY:'translateY(-100%)',
        listGoneVisible:false,
				
				iframeHeight:'0',
				conentsLoading:true,
				/* 新料快报 */
				list: [],
				loading: false,
				finished: false,
				newsBaoClass: {
					newbaoListHeight: '212px',
				},
				articleSrc:'',
			}
		},
		mounted() {
			let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
			let elementWith = (w * 0.1826);
			if(w >= 750) {
				elementWith = 137;
				w = 750;
			}
			this.titleHeight = elementWith + 'px';
			this.navIconHeight = (elementWith * 0.3764) + 'px';
			this.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
			let vm = this;
			window.onresize = function temp() {
				let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
				let elementWith = (w * 0.1826);
				if(w >= 750) {
					elementWith = 137;
					w = 750;
				}
				vm.titleHeight = elementWith + 'px'
				vm.navIconHeight = (elementWith * 0.3764) + 'px';
				vm.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
			};
		},
		created() {
			let type =parseInt(this.$route.query.type);
		 this.back = this.$route.query.back;
		 
		     switch(type){
	  			case 203:
    				document.title = '全村第一站1'
            this.newsType = 203
	  			break;
	  			case 204:
    				document.title = '趣玩攻略2' 
	  				this.newsType = 204 
	  			break; 
          case 1003:
            document.title = '村长甄选'
            this.newsType = 1003
            this.newsZid = 12
          break; 
	  			case 3:
    				document.title = '村长甄选3'   
            this.active=3; 
	  			break; 
	  		}
		    

		},
		methods: {
     //-评论=============================================================    
      //点击评论按钮
      handleComment(){
        //显示评论窗口
        this.commentVisible = true
        //清空数据
        let vm = this
        setTimeout(function(){
          vm.commentY = 'translateY(0)'  
        },50);   
         //子组件加载数据
        this.$refs.articleComments.loadComment(this.newsId)
      },        
      //关闭评论窗口
       closeComment(){ 
         this.commentFinished  = true
         this.commentY = 'translateY(-100%)';
         let vm = this
         setTimeout(function(){
            vm.commentVisible = false
         },400); 
      },         
      //-评论 end ==========================================================
        
      
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			    //关闭公共窗口
    closeAllCommon(){
      let type =parseInt(this.$route.query.type)
      let id =this.$route.query.id
       this.c("type",type)
     // 关闭评论窗口
      if(this.commentY == 'translateY(0)' || this.commentY == 'none' ){
       this.commentY = 'translateY(-100%)'
       this.c("commentY",this.commentY) 
       this.c("handleNavNew","关闭评论窗口")
       this.setTypeInfo(type,id,this.back)
        return true
     }
      //-从[村长甄选]入口
      if(type==1 || type==3 || type==4){
        this.$router.push({
          path: '/',
          query: {
            view: type
          }
       })
        return true
      }
     //关闭文章窗口
      if(this.articleY == 'translateY(0)'){
       this.c("handleNavNew","关闭文章窗口")
       this.c("articleY",this.articleY)
       this.c("type",type)
       this.articleY = 'translateY(-100%)'  
       this.setTypeInfo(type,'',this.back)
       return true
      } 
    },
			
			
		//点击趣玩导航栏
		handleNavPlay(){
				
				let type = this.$route.query.type;
      this.c("handleNavPlay","点击[趣玩]主菜单")
     //从别的地方跳转来,回到主菜单
  /*  if(type != 3){      
        this.$router.push({
            path: '/',
            query: {
              view: 3
            }
        });
        return
      }
      */
      
      
       
       if(this.closeAllCommon()){
        return
      }
    
 
				
		 
			   
      if(this.back=='search'){
          this.$router.push({
              path: '/',
              query: {
                view: 4
              }
           });
      }else if(type == 203 || type == 204 || type == 205 || type == 3 || type == 1003){
        this.$router.push({
              path: '/',
              query: {
                view: 3
              }
           });
      }else if(type == 1003 ){
        this.$router.push({
              path: '/',
              query: {
                view: 3
              }
           });
      }else if(this.articleSrc==''){
        this.$router.push({
              path: '/',
              query: {
                view: 1
              }
           });
      }  else{
          //显示列表
          this.newClass.activeHeight = '100%';
          this.newClass.articleHeight = '0';          
          this.articleSrc = '';
       }
			
			
			
		},
		//
		iframeLoaded(){console.log('iframeLoaded');
			this.iframeHeight='100%';
			this.conentsLoading = false;
		},
    //
      getData(cid){
        console.log('cid',cid);
        console.log('HOST',this.HOST);
        let vm  = this;       
        //Toast('正在加载...');//return;
        let data =this.listQuery;
        data.cid = cid;
        data.zid = this.newsZid; //村长甄选ID
        data = qs.stringify(data);
        request.post(this.HOST+'/Action/NewsAction.aspx?action=getByCategory',data)
      .then(function (res) {
          vm.loading = false;
        if(res.data.state==1){ 
          console.log(res.data)
          for(var i =0;i<res.data.list.length;i++){
            try{
              vm.list.push(res.data.list[i]);
            }catch(e){
              
            }
          }  
          if(res.data.list.length<=0){
             if(vm.list.length>0){
                  vm.listGoneVisible = true
                }
            vm.finished = true;
          }else{
            vm.listQuery.pageIndex++;
          }
          //vm.list.push(res.data.list);  
          //Toast.clear();
       } else {
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        console.log(response);
      });
        
        
        
      },
    	//显示文章
    	displayArticle(id,type){
        //显示文章窗口
        let vm = this
        this.articleVisible = true
        setTimeout(function() {
          vm.articleY = 'translateY(0)'  
        }, 50);     
        this.newsId = id
        setTimeout(function() {
          //vm.articleY = 'none'  
          vm.articleSrc = vm.HOST + '/View/Article.aspx?id=' + vm.newsId
        }, 50)

        this.conentsLoading = true;
        window.location.hash = '/playlist?type=' + type + "&id=" + id;
        setTimeout(function() {
          vm.conentsLoading = false;
        }, 8000);
    	},
			onLoad() {
			  if(!this.finished){
        console.log('onLoad:',new Date());
        this.getData(this.newsType);
      }
				 
			},
			//鲜料
			displayNewComponents() {

				if(this.newClass.activeHeight == '0') {
					this.newComponentsShow = true;
					this.payClass.activeHeight = '0';
					this.serviceClass.activeHeight = '0';
					this.newClass.activeHeight = 'calc(100%  - ' + this.titleHeight + ' + 1px)';
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 99999999);
					this.$refs.slider.$emit('slideTo', 0);
					this.$refs.slider.basicdata.currentPage = 0;
					this.activeColor = "#222633";
					//this.$refs.slider.$emit('slideNext');
					//this.$refs.slider.$emit('autoplayStop');   
					this.active = 0;

				} else {
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 3000);
					this.newClass.activeHeight = '0';
					this.active = 10;
				}
			},

			//趣玩
			displayPayComponents() {
				if(this.payClass.activeHeight == '0') {
					this.newClass.activeHeight = '0';
					this.serviceClass.activeHeight = '0';
					this.payClass.activeHeight = 'calc(100%  - ' + this.titleHeight + ' + 1px)';
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 99999999);
					this.$refs.slider.$emit('slideTo', 0);
					this.$refs.slider.basicdata.currentPage = 0;
					this.activeColor = "#222633";
					this.active = 2;
				} else {

					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 3000);
					this.payClass.activeHeight = '0';
					this.active = 10;
				}
			},

			//服务
			displayServiceComponents() {
				if(this.serviceClass.activeHeight == '0') {
					this.newClass.activeHeight = '0';
					this.payClass.activeHeight = '0';
					this.serviceClass.activeHeight = 'calc(100%  - ' + this.titleHeight + ' + 1px)';
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 99999999);
					this.$refs.slider.$emit('slideTo', 0);
					this.$refs.slider.basicdata.currentPage = 0;
					this.activeColor = "#222633";
					this.active = 3;
				} else {
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 3000);
					this.serviceClass.activeHeight = '0';
					this.active = 10;
				}
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* 列表 */
 .list-gone{
  width: 100%;
  text-align: center;
  line-height: 55px;
  height: 55px;
  padding-bottom: 3%;
 }
  /* 列表  end*/
 /* 文章 */
 .article-components{
    position:relative;
    z-index: 3;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling:touch;
    -webkit-transition: transform 400ms;
    transition: transform 400ms;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
 }
 .btn-comments{
    position: fixed;
    top: 11.5%;
    width: 11%;
    right: 8.3%;
    z-index: 2;
 }
 /* 文章 end*/
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
	
	.menu-components {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 3;
		width: 100%;
		height: 0;
		overflow: hidden;
		background-color: #FFF;
	}
	.eye{
		width: 22%;
		margin-right: 0.05rem;
		margin-bottom: 0.03rem;
	}
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	  /* 文章 */
 .article-components{
    position:relative;
    z-index: 3;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling:touch;
    -webkit-transition: transform 400ms;
    transition: transform 400ms;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
 }

 .btn-comments{
    position: fixed;
    top: 11.5%;
    width: 11%;
    right: 8.3%;
    z-index: 2;
 }
 /* 文章 end*/
 /* 评论 */

 .comments-total{
    position: fixed;
    top: 10%;
    right: 7%;
    z-index: 2;
    color: #fff;
    font-size: 15px;
    font-weight: normal;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
    text-align: center;
    box-sizing: border-box;
    padding: 0 6px;    
    min-width: 28px;
    line-height: 28px;
    border-radius: 16px;
    background-color: rgba(0, 145, 67, 0.8);
 }
 .comment-components{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 4;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
    overflow: hidden;
    -webkit-overflow-scrolling:touch;
    -webkit-transition: transform 400ms;
    transition: transform 400ms;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
 } 
 /* 评论 end*/
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
</style>
<style>
	
.child-view {  
  position: absolute;  
  left: 0;  
  top: 0;  
  width: 100%;  
  height: 100%;  
  transition:none !important;   /*转场动画*/
}


</style>

<!-- 菜单 -->
<style scoped>
   
  
  
  
  
  
  
    .conents-loading{
  	position: absolute;
  	top:20%;
  	left:45%;
  	}
	.view-funnyplaylist-warp .new-list-wrap {
		margin-top: 30px;
		margin-bottom: 100px;
	}
	 
	
	.view-funnyplaylist-warp .new-list .van-col:nth-child(odd) {
		margin-bottom: 0 !important;
		padding-left: 17px !important;
		padding-right: 6px !important;
	}
	
	.view-funnyplaylist-warp .new-list .van-col:nth-child(even) {
		margin-bottom: 0 !important;
		padding-left: 6px !important;
		padding-right: 17px !important;
	}
	
	.view-funnyplaylist-warp .content-title{ 		
		font-size: 0.34rem;
		line-height: 0.38rem;
		height:  1.121rem;
		/*将height设置为line-height的整数倍，防止超出的文字露出*/
		color: #222633;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;  
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
	}
	
	.newbao-list-wrap {
		position: relative;
		height:100%;
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling:touch;
	}
</style>
<style>
	
	.view-funnyplaylist-warp .new-menu {
		margin-top: 10px;
	}
	
	.view-funnyplaylist-warp .new-menu img {
		height: 17px !important;
		/*16px*/
		width: auto;
		margin-bottom: 8px;
	}
	
	.view-funnyplaylist-warp .list-title {
		height: 17px !important;
		/*53%!important;*/
		margin-bottom: 10px!important;
		width: auto;
	}
	
	.view-funnyplaylist-warp .new-list-wrap .van-cell__value,
	.view-funnyplaylist-warp .new-menu .van-cell {
		font-size: 15px;
		font-weight: bold;
		padding: 6px 15px;
	}
	
	.view-funnyplaylist-warp .new-list-wrap .van-cell__value--alone {
		padding: 0;
	}
	
	.new-list-wrap .van-col:nth-child(even) {
		/*background-color: #66c6f2;*/
	}
	
	.view-funnyplaylist-warp .new-list-wrap .van-col {
		color: #fff;
		font-size: 13px;
		line-height: 30px;
		text-align: center;
		margin-bottom: 10px;
		background-clip: content-box;
	}
	
	.view-funnyplaylist-warp .new-list-wrap .van-col:nth-child(odd) {
		/*background-color: #39a9ed;*/
	}
	
	.view-funnyplaylist-warp .news-list-title .van-cell {
		padding-bottom: 0 !important;
	}
	/* 城事精选 */
	
	.view-funnyplaylist-warp .quancun-list-wrap {
		position: relative;
	 /*height: calc(100% - 1.37rem); */
	height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
    -webkit-overflow-scrolling:touch;
      background-color: #e8e9eb;
	}
	.view-funnyplaylist-warp .quancun-list-wrap .van-cell {
		width: 3.65rem;
		height: calc(4.87rem + 0.15rem);	
		padding: 0;
		border-top: 0.18rem solid #e8e9eb;
		 display:inline-flex;
	}
	.view-funnyplaylist-warp .quancun-list-wrap .van-cell:nth-of-type(odd){	
		width: calc(3.65rem + 0.2rem);	 
		border-right: 0.2rem solid #e8e9eb;
	}
	.view-funnyplaylist-warp .quancun-list-wrap .van-cell__value--alone {
		
		/*height: calc(2.75rem + 2.12rem);*/
		 
	}
	
	 
	.view-funnyplaylist-warp .quancun-list-img {
		position: relative;
		width: 100%;
		height: 2.75rem;
		right: 0;
		top: 0;
		background-color: #FFF;
		background-position: center;
		background-size: auto 100%;
	}
	
  
	
	.view-funnyplaylist-warp .quancun-list-bottom {
		position: absolute;
		bottom: 0.27rem;
		width: calc(100% - 0.27rem );
		line-height: 0.26rem;
		font-size: 0.26rem;
		color: #8A8A8A;
	}
	
	.view-funnyplaylist-warp .quancun-list-bottom span:nth-child(1) {
		 
	}
	
	.view-funnyplaylist-warp .quancun-list-bottom span:nth-child(2) {
		position: absolute;		
		right: 0.41rem;
		top: 0;
		width: 30%;
		text-align: right;		
	}
	.view-funnyplaylist-warp .van-loading--white {
    padding: 10px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, .5);
    margin: auto;
    margin-top: 35%;
}
	/* 城事精选 end*/
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	  
</style>


// WEBPACK FOOTER //
// src/components/funnyplay/List.vue